import { TaskAPI } from "@griffingroupglobal/eslib-api";

const fetchTasksHandler = async (requestString, signal) => {
  const response = await TaskAPI.getWOP(requestString, { signal });
  return response?.data?.entries || [];
};

export default fetchTasksHandler;
